/**
 * Simple activity tracker for monitoring user interactions
 * react-idle-timer handles the actual idle detection and logout
 */
class ActivityTrackerService {
  private lastActivity: number = Date.now();

  constructor() {
    this.setupActivityListeners();
  }

  /**
   * Sets up event listeners for user activity tracking
   * @private
   */
  private setupActivityListeners() {
    const events = ['mousedown', 'keypress', 'scroll', 'touchstart'];
    
    const updateActivity = () => {
      this.lastActivity = Date.now();
    };

    events.forEach(event => {
      document.addEventListener(event, updateActivity, true);
    });
  }

  /**
   * Manually record activity (called from API interceptor)
   */
  recordActivity(): void {
    this.lastActivity = Date.now();
  }

  /**
   * Get last activity timestamp
   */
  getLastActivity(): number {
    return this.lastActivity;
  }
}

export const activityTracker = new ActivityTrackerService();
